import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typeahead'
})
export class TypeaheadPipe implements PipeTransform {

  transform(value: TypeaheadOption[], searchTerm: string = ""): TypeaheadOption[] {
    if (!searchTerm) return value.slice(0, 10);

    const cleanedSearch = searchTerm.replace(/['.]/g, "").toLowerCase();

    return value.filter(item => {
      const cleanedName = item.name.replace(/['.]/g, "").toLowerCase();
      return cleanedName.includes(cleanedSearch);
    }).slice(0, 10);
  }
}
